import React, { memo, useContext } from 'react';
import { AuthorContext } from '../../contexts/AuthorContext';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { useInstantSearch } from 'react-instantsearch-hooks-web';

interface ArticlesPublishedBlokProps extends Blok {
  image: StoryblokAsset;
  arrow_image?: StoryblokAsset;
  heading: string;
  title?: string;
  body?: string;
  articles_published: number;
}

interface ArticlesPublishedProps {
  blok: ArticlesPublishedBlokProps;
}

const ArticlesPublished: React.FC<ArticlesPublishedProps> = ({ blok }) => {
  const {
    results,
    results: { nbHits, hits, hitsPerPage },
  } = useInstantSearch();

  return (
    <p className="text-text/body text-sm py-4">
      <strong>Published:</strong> {nbHits} articles
    </p>
  );
};

export default memo(withBlokWrapper(ArticlesPublished, Theme.DARK));
